import React from 'react';
import { DISCOVER_APP_URL } from 'src/utilities/envConfig';

/**
 * This return adds the discover app under an optimizely tab for the AI Team.
 *
 * It is TEMPORARY and will be removed after the testing has completed.
 *
 * @returns rendered discover app
 */
export const DiscoverShelf: React.FC = () => {
	return (
		<div>
			<iframe
				height='500px'
				id='discover-iframe'
				src={DISCOVER_APP_URL}
				title='Discover AI Recommendations'
				width='100%'
			></iframe>
		</div>
	);
};
